import { InjectionToken } from '@angular/core';

export const DOCUMENT: InjectionToken<Document> = new InjectionToken<Document>(
    'Document extension',
    {
        providedIn: 'root',
        factory: () => window.document,
    }
);
